import _ from 'underscore';

import { getIndex } from 'app/src/components/Navigation/SearchUtils';
import type { Template } from './types';

export const createSearchIndex = (templates?: Template[]) => {
  const searchNameIndex = getIndex();
  const searchIndex = getIndex();
  templates?.forEach((template) => {
    if (template.name) {
      searchNameIndex.add(template.id, template.name);
    }
    if (template.templateGallery?.blurb) {
      searchIndex.add(template.id, template.templateGallery.blurb);
    }
  });

  return {
    search(query: string): Template[] {
      const nameResults = searchNameIndex.search(query, 5);
      const blurbResults = searchIndex.search(query, 25);
      return _.uniq(nameResults.concat(blurbResults)).map(
        // @ts-expect-error
        (idTemplate: string) =>
          templates?.find((template) => template.id === idTemplate) as Template,
      );
    },
  };
};

export const SearchHelper = {
  createSearchIndex,
};
